{
  "version": 1,
  "asset_id": "32f39281-69fe-4233-a1ce-a95468766479",
  "project_id": "310fa6a9-80bb-43be-9048-dd5bd4b41bc6",
  "url": "/__l5e/assets-v1/32f39281-69fe-4233-a1ce-a95468766479/Sadaf_Intro_Video_Womens_Pelvic_Health.mov",
  "r2_key": "a/v1/310fa6a9-80bb-43be-9048-dd5bd4b41bc6/32f39281-69fe-4233-a1ce-a95468766479/Sadaf_Intro_Video_Womens_Pelvic_Health.mov",
  "original_filename": "Sadaf_Intro_Video_Womens_Pelvic_Health.mov",
  "size": 58262763,
  "content_type": "video/quicktime",
  "created_at": "2026-09-12T08:24:32Z"
}
